import ContactLink from "@/components/ContactLink";
import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import { Card, CardContent } from "@/components/ui/card";

function PublicDonationsList() {
  return (
    <Card>
      <CardContent className="p-5 space-y-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Recent donations</p>
        <div className="space-y-2.5 text-sm">
          <div className="flex items-start justify-between border-b border-border pb-2.5">
            <div>
              <p className="font-medium text-foreground">Karen H.</p>
              <p className="text-xs text-muted-foreground italic">"Go Sarah! 📚"</p>
            </div>
            <p className="font-mono tabular-nums text-primary font-semibold">$50</p>
          </div>
          <div className="flex items-start justify-between border-b border-border pb-2.5">
            <div>
              <p className="font-medium text-muted-foreground italic">Anonymous</p>
              <p className="text-xs text-muted-foreground italic">"Proud of you, kiddo. Read every page!"</p>
            </div>
            <p className="font-mono tabular-nums text-primary font-semibold">$25</p>
          </div>
          <div className="flex items-start justify-between">
            <div>
              <p className="font-medium text-muted-foreground italic">Anonymous</p>
            </div>
            <p className="font-mono tabular-nums text-primary font-semibold">$10</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function AnonymousDonationsAndMessages() {
  return (
    <>
      <p>
        Every donation shows up on the student's page with the donor's name, the amount, and an optional message. Two boxes at checkout let you adjust this: one hides your name, the other lets you leave a note for the student.
      </p>

      <h2>Hiding your name</h2>
      <p>
        Tick the anonymous box and your name shows as "Anonymous" everywhere it appears publicly — to other donors, the parents, and the student. The school still has your real name in their records (so they can help if you ever ask for a refund), but it never appears on a public page.
      </p>
      <Screenshot caption="Anonymous donations on a public page">
        <div className="max-w-md mx-auto">
          <PublicDonationsList />
        </div>
      </Screenshot>

      <h2>Leaving a message</h2>
      <p>
        A short note that shows up next to your donation. The student sees it on their dashboard, the parents see it, and family members who visit the page later see it too. Anonymous donors can still leave a message — only your name is hidden.
      </p>
      <p>Some good ones:</p>
      <ul>
        <li>"Go Sarah! 📚 — Aunt Karen"</li>
        <li>"Proud of you, kiddo. Read every page!"</li>
        <li>"From the Henderson family"</li>
      </ul>

      <Callout variant="tip" title="Messages are public — keep them friendly">
        <p>
          Treat it like a note in a card. Supportive, short, easy for a 9-year-old to read.
        </p>
      </Callout>

      <p>
        If you ever see something inappropriate, the school can hide it right away — and if you'd like to flag it, email <ContactLink>hello@pagepledge.com</ContactLink> and we'll take care of it.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/making-a-donation">How to make a donation</Link>.</li>
        <li><Link href="/help/articles/donor-receipts-and-refunds">Receipts and refunds</Link>.</li>
      </ul>
    </>
  );
}
